import React from 'react';
import { PLATFORMS } from '../../utils/platformConfig';
import { useLanguage } from '../../contexts/LanguageContext';
import { PlatformIcon } from '../icons/PlatformIcons';

const PlatformSelector = ({ value, onChange, disabled = false, allowedPlatforms = null }) => {
  const { isRTL } = useLanguage();
  let platforms = Object.values(PLATFORMS);
  
  // Filter platforms if allowedPlatforms is provided (null = all platforms allowed)
  if (allowedPlatforms && Array.isArray(allowedPlatforms) && allowedPlatforms.length > 0) {
    platforms = platforms.filter(p => allowedPlatforms.includes(p.id));
  }

  return (
    <div className="space-y-4">
      <label className="block text-sm font-medium text-gray-700">
        {isRTL ? 'اختر المنصة' : 'Select Platform'} <span className="text-red-500">*</span>
      </label>
      
      {platforms.length === 0 ? (
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-800">
            {isRTL 
              ? 'لا توجد منصات متاحة في الباقات النشطة للعميل. يرجى إضافة باقة تحتوي على المنصات المطلوبة.' 
              : 'No platforms available in the client\'s active packages. Please add a package with the required platforms.'}
          </p>
        </div>
      ) : (
        <>
          {allowedPlatforms && allowedPlatforms.length > 0 && (
            <div className="mb-2 p-2 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-xs text-blue-700">
                {isRTL 
                  ? `المنصات المتاحة في باقات العميل: ${platforms.map(p => isRTL ? p.nameAr : p.name).join(', ')}`
                  : `Available platforms from client packages: ${platforms.map(p => p.name).join(', ')}`}
              </p>
            </div>
          )}
          
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
            {platforms.map((platform) => {
          const isSelected = value === platform.id;
          
          return (
            <button
              key={platform.id}
              type="button"
              disabled={disabled}
              onClick={() => onChange(platform.id)}
              className={`
                relative flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all duration-200
                ${
                  isSelected 
                    ? 'border-sky-500 bg-sky-50 shadow-sm scale-105' 
                    : 'border-gray-200 bg-white hover:border-sky-200 hover:bg-sky-50/60 hover:shadow-md'
                }
                ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
              `}
            >
              {/* Platform Icon */}
              <div 
                className={`
                  w-12 h-12 rounded-xl flex items-center justify-center mb-2 transition-all duration-200
                  ${
                    isSelected 
                      ? platform.bgColor + ' text-white shadow-md' 
                      : 'bg-gray-100'
                  }
                `}
              >
                <PlatformIcon platformId={platform.id} className="w-7 h-7" />
              </div>
              
              {/* Platform Name */}
              <span className={`text-sm font-medium transition-colors ${isSelected ? 'text-sky-800 font-semibold' : 'text-gray-700'}`}>
                {isRTL ? platform.nameAr : platform.name}
              </span>
              
              {/* Selection Indicator */}
              {isSelected && (
                <div className="absolute top-2 right-2 bg-sky-500 rounded-full p-1 shadow-md">
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </button>
          );
            })}
          </div>
        </>
      )}
      
      {/* Selected Platform Info */}
      {value && (
        <div className="flex items-center gap-2 p-3 rounded-lg bg-gray-50 text-sm text-gray-600">
          <PlatformIcon platformId={value} className="w-5 h-5" />
          <span>
            {isRTL 
              ? `تم اختيار ${PLATFORMS[value]?.nameAr}` 
              : `Selected: ${PLATFORMS[value]?.name}`
            }
          </span>
        </div>
      )}
    </div>
  );
};

export default PlatformSelector;





